import { addMutator } from '@poa/state';
import {
  changeGrouping,
  changeStatus,
  fetch,
  fetchFailed,
  fetchSuccess,
  resetGrouping,
  resetStatuses,
  setDates
} from './calendar.actions';

function normalizeIncome(income) {
  let normalizedIn = 0;
  let normalizedOut = 0;
  let normalizedFirst = 0;

  if (income.in && typeof income.in !== 'string') {
    normalizedIn = income.in;
  }

  if (income.out && typeof income.out !== 'string') {
    normalizedOut = income.out;
  }

  if (income.first && typeof income.first !== 'string') {
    normalizedFirst = income.first;
  }

  return { in: normalizedIn, out: normalizedOut, first: normalizedFirst };
}

function displayIncome(income) {
  if (!income) {
    return `-/-`;
  }

  if (income.in && !income.out) {
    return `${income.in}/-`;
  }

  if (income.out && !income.in) {
    return `-/${income.out}`;
  }

  return `${income.in}/${income.out} (${income.first})`;
}

// fetch
addMutator(fetch, (payload, { store }) => {
  store.calendar.meta.isLoading = true;
  store.calendar.meta.hasError = false;
});

addMutator(fetchSuccess, ({ data }, { store }) => {
  store.calendar.meta.isLoading = false;
  store.calendar.meta.hasError = false;

  if (!data.girls) {
    return null;
  }

  const body = data.girls.map(girl => {
    const finalObject = {
      id: undefined,
      section_1: {
        // '~': { value: 0 }
        team_leader: '',
        total: { value: '-' }
      }
    };

    const incomeById = data.incomes_data[girl.id];
    // const missedDays = finalObject.section_1['~'];

    Object.keys(girl).forEach(key => {
      if (key === 'site_id') {
        finalObject.section_1[key] = { value: parseInt(girl[key], 10) };
      } else {
        finalObject.section_1[key] = { value: girl[key] };
      }
    });

    finalObject.id = girl.id;

    const total = {
      first: 0,
      in: 0,
      out: 0
    };

    data.days_range.forEach(dateArray => {
      const [year, month, day] = dateArray;

      if (!incomeById) {
        finalObject.section_1[day] = { value: displayIncome() };
        return;
      }

      try {
        const income = incomeById[year][month][day];

        if (income) {
          const normalizedIncome = normalizeIncome(income);

          total.first += normalizedIncome.first;
          total.in += normalizedIncome.in;
          total.out += normalizedIncome.out;

          finalObject.section_1[day] = { value: displayIncome(income) };
        } else {
          finalObject.section_1[day] = { value: '' };
          // missedDays.value = missedDays.value + 1;
        }
      } catch (e) {
        finalObject.section_1[day] = { value: '' };
        // missedDays.value = missedDays.value + 1;
      }
    });

    finalObject.section_1.total.value = displayIncome(total);

    return finalObject;
  });

  store.calendar.data = [
    {
      thead: {
        section_1: [
          {
            verbose_name: 'панель',
            name: 'site_id'
          },
          {
            verbose_name: 'ФИО',
            name: 'full_name'
          },
          {
            verbose_name: 'ник',
            name: 'fn'
          },

          {
            verbose_name: 'тимлид',
            name: 'team_leader'
          },
          {
            verbose_name: 'оператор',
            name: 'translator'
          },
          {
            verbose_name: 'итого',
            name: 'total'
          },
          // {
          //   verbose_name: '~',
          //   name: '~'
          // },
          ...data.days_range.map(day => ({ verbose_name: day[2], name: day[2] }))
        ]
      },
      tbody: body
    }
  ];

  store.calendar.meta.loaded = true;
});

addMutator(fetchFailed, (payload, { store }) => {
  store.calendar.meta.isLoading = false;
  store.calendar.meta.hasError = true;
});

addMutator(setDates, (payload, { store }) => {

  if (payload.startDate) {
    store.calendar.filters.startDate = payload.startDate;
  }

  if (payload.endDate) {
    store.calendar.filters.endDate = payload.endDate;
  }
});

addMutator(changeGrouping, ({ grouping }, { store }) => {
  store.calendar.filters.grouping.selected = grouping;
});

addMutator(resetGrouping, ({ grouping }, { store }) => {
  store.calendar.filters.grouping = grouping;
});

// statuses
addMutator(changeStatus, ({ status }, { store }) => {
  store.calendar.filters.status.selected = status;
});

addMutator(resetStatuses, ({ statuses }, { store }) => {
  store.calendar.filters.status = statuses;
});
